
import React, { useEffect, useRef, useState } from 'react';
import { Hero } from '../NewComponents/sections/Hero';
import CollabrativeSpace from '../NewComponents/sections/CollabrativeSpace';
import { AmenitiesSection } from '../NewComponents/sections/AmenitiesSection';
import { FeaturesSection } from '../NewComponents/sections/FeaturesSection';
import { ClientsSection } from '../NewComponents/sections/ClientsSection';
import { FAQSection } from '../NewComponents/sections/FAQSection';
import BookATour from '../NewComponents/sections/BookATour';
import { Header } from '../NewComponents/layout/Header';
import { FloatingBookButton } from '../NewComponents/ui/FloatingBookButton';
import PricingPlanAffordability from '../NewComponents/sections/PricingPlanAffordability';
import TestimonialsSection from '../NewComponents/sections/TestimonialsSection';
import MapSection from '../NewComponents/sections/MapSection';
import { Footer } from '../NewComponents/layout/Footer';
import { PerungudiHero } from '../NewComponents/sections/PerungudiHero';
import { HeroAffordabilityPerungudi } from '../NewComponents/sections/HeroAffordabilityPerungudi';

const LandingPageAffordabilityPerungudi = () => {
  const mapRef = useRef(null);
  return (
    <div className="bg-white flex flex-col overflow-hidden items-center">
      <Header />
      <FloatingBookButton />
      <main>
        <div>
          <HeroAffordabilityPerungudi />
        </div>
        <div>
          <CollabrativeSpace />
        </div>
        <div>
          <FeaturesSection />
        </div>
        <div id="amenities">
          <AmenitiesSection />
        </div>
        <div>
          <ClientsSection />
        </div>
        <div>
          <PricingPlanAffordability />
        </div>
        <div>
          <TestimonialsSection />
        </div>
        <div>
          <FAQSection />
        </div>
        <div ref={mapRef}>
          <MapSection />
        </div>
        <div className='w-[100vw]'>
          <Footer />
        </div>
      </main>
    </div>
  );
};

export default LandingPageAffordabilityPerungudi;
